import { facilitySettingRequest } from "./facilitySettingRequest";

export default facilitySettingRequest;
